import VehiculeEntete from './vehicule.entete.model';
let ptraTracteur = 9999;
let ptacBenne = 9999;

export default class VehiculeEnteteController {
	static $inject = ['$stateParams', 'VehiculesCommunicationService', 'VehiculesService', 'VehiculesTypesService', 'notification', 'BennesService'];

	constructor($stateParams, VehiculesCommunicationService, VehiculesService, VehiculesTypesService, notification, BennesService) {
		this.$stateParams = $stateParams;
		this.VehiculesCommunicationService = VehiculesCommunicationService;
		this.VehiculesService = VehiculesService;
		this.VehiculesTypesService = VehiculesTypesService;
		this.notification = notification;
		this.BennesService = BennesService;
	}

	async $onInit() {
		this.loading = false;
		this.isEditMode = false;
		this.hasTypes = false;
		this.ptacType = [];
		this.typesBennes = [];
		this.immatbennes = [];
		this.immatTracteurs = [];

		this.unregisterReinit = this.VehiculesCommunicationService.registerReinit(() => this.initForm());
		await this.initForm();
	}

	$onDestroy() {
		this.unregisterReinit();
	}

	async initForm() {
		await this.getTypePtac();
		let entete = {};

		if (this.$stateParams && this.$stateParams.id) {
			this.isEditMode = true;
			entete = this.vehicule.entete;
		} else {
			this.isEditMode = false;
		}

		this.vehicule.entete = new VehiculeEntete(entete);
		await this.getTypes();
		await this.getSites();
		await this.getChauffeurs();

		this.immatBennes = await this.getImmatBennes();
		this.immatTracteurs = await this.getImmatTracteurs();
		await this.getTypesBennes();
	}

	async getTypePtac() {
		const res = await this.VehiculesService.getTypePtac();
		this.typePtac = res;
	}

	async changeTypePtac(idTypePtac) {
		let ptacVehicule = 0;
		const selectedTypePtac = this.typePtac.find((typePtac) => typePtac.id === idTypePtac);
		const ptacBenne = this.isEditMode ? this.vehicule.entete?.ptacBenne : this.vehicule.entete?.objetImmatBenne?.ptacBenne;
		const ptraTracteur = this.isEditMode ? this.vehicule.entete?.ptraTracteur : this.vehicule.entete?.objetImmatTracteur?.ptraTracteur;

		switch (selectedTypePtac.libelle) {
			case 'Défaut':
				ptacVehicule = Math.min(ptacBenne == null ? 0 : ptacBenne, ptraTracteur == null ? 0 : ptraTracteur);
				break;
			case 'PTRA':
				ptacVehicule = ptraTracteur != null ? ptraTracteur : 0;
				break;
			case 'PTAC':
				ptacVehicule = ptacBenne != null ? ptacBenne : 0;
				break;
			default:
				ptacVehicule = this.vehicule.entete.customPtac;
				break;
		}

		this.vehicule.entete.idTypePtac = idTypePtac;
		this.vehicule.entete.ptacVehicule = ptacVehicule;
	}

	async modifyPTAC(pValue) {
		if (pValue == 1 && this.vehicule.entete.objetImmatTracteur != undefined && this.vehicule.entete.objetImmatTracteur != 'string') {
			ptraTracteur = typeof this.vehicule.entete.objetImmatTracteur.ptraTracteur;
		} else {
			ptraTracteur = 9999;
		}
		if (pValue == 2 && this.vehicule.entete.objetImmatBenne != undefined && this.vehicule.entete.objetImmatBenne != 'string') {
			ptacBenne = this.vehicule.entete.objetImmatBenne.ptacBenne;
		} else {
			ptraTracteur = 9999;
		}
		this.vehicule.entete.ptacVehicule = Math.min(ptraTracteur, ptacBenne);
	}

	async getTypes() {
		this.startLoading();

		try {
			this.types = await this.VehiculesTypesService.getAll();
			this.hasTypes = this.types.length > 0;
		} catch (ex) {
			this.notification.error(ex.data);
		} finally {
			this.stopLoading();
		}
	}

	async getImmatBennes(valeur) {
		try {
			const res = await this.VehiculesService.getImmatBennes(valeur || '');
			return res;
		} catch (ex) {
			this.notification.error(ex.data);
		}
	}

	async getImmatTracteurs(valeur) {
		try {
			const res = await this.VehiculesService.getImmatTracteurs(valeur || '');
			return res;
		} catch (ex) {
			this.notification.error(ex.data);
		}
	}

	async getChauffeurs() {
		this.startLoading();
		try {
			const res = await this.VehiculesService.getChauffeurs(-1);
			this.chauffeurs = res;
			const idTransporteur = this.vehicule.entete.siteId || -1;
			//liste pour le selecteur
			this.filtredChauffeurs = angular
				.copy(this.chauffeurs)
				.filter((chauffeur) => idTransporteur === -1 || chauffeur.idSiteTransporteur === idTransporteur);
		} catch (ex) {
			this.notification.error(ex.data);
		} finally {
			this.stopLoading();
		}
	}

	async getSites() {
		this.startLoading();
		try {
			this.sites = await this.VehiculesService.getSites();
		} catch (ex) {
			this.notification.error(ex.data);
		} finally {
			this.stopLoading();
		}
	}

	startLoading() {
		this.loading = true;
	}

	stopLoading() {
		this.loading = false;
	}

	saveSelectedSite(site) {
		this.vehicule.entete.siteId = site.selected ? site.id : undefined;
		this.vehicule.entete.chauffeurId = undefined;
		this.filtredChauffeurs = site.selected
			? angular.copy(this.chauffeurs).filter((chauffeur) => chauffeur.idSiteTransporteur === site.id)
			: angular.copy(this.chauffeurs);
	}

	saveSelectedChauffeur(chauffeur) {
		this.vehicule.entete.chauffeurId = chauffeur.selected ? chauffeur.id : undefined;
		if (chauffeur.selected) {
			this.vehicule.entete.siteId = this.sites.find((site) => site.id === chauffeur.idSiteTransporteur).id;
		}
	}

	async getTypesBennes() {
		try {
			this.typesBennes = await this.BennesService.getTypeBennes();
		} catch (ex) {
			this.notification.error(ex.data);
		}
	}

	saveSelectedTypeBenne(typeBenne) {
		if (!this.isBenneObject()) {
			return;
		}

		this.vehicule.entete.idTypeBenne = typeBenne.selected ? typeBenne.id : undefined;
		this.vehicule.entete.nomTypeBenne = typeBenne.selected ? typeBenne.libelle : undefined;
	}

	setTypebenne(benne) {
		this.vehicule.entete.idTypeBenne = benne?.idTypeBenne ?? undefined;
		this.vehicule.entete.nomTypeBenne = benne?.nomTypeBenne ?? undefined;
	}

	isBenneObject() {
		return this.vehicule.entete.objetImmatBenne !== null && typeof this.vehicule.entete.objetImmatBenne === 'object';
	}

	saveSelectedImmatBenne(benne) {
		this.vehicule.entete.objetImmatBenne = benne.selected ? benne : undefined;
		this.modifyPTAC(2);
		this.tmp.immatBenne.length === 0 ? this.setTypebenne(null) : this.setTypebenne(benne);
	}

	saveSelectedImmatTracteur(tracteur) {
		this.vehicule.entete.objetImmatTracteur = tracteur.selected ? tracteur : undefined;
		this.modifyPTAC(1);
	}
}
